import axios from 'axios';
import { CertificateDetailsModel } from 'models/certificate.model';

const getCertificates = async () => {
  const response = await axios.get<CertificateDetailsModel[]>('/certificates');

  return response.data;
};

const addCertificate = (cert: CertificateDetailsModel) => {
  return axios.post('/certificates', cert);
};

const getCertificateDetails = async (id: string) => {
  const response = await axios.get<CertificateDetailsModel>(`/certificates/${id}`);

  return response.data;
};

const getDrafts = async () => {
  const response = await axios.get<CertificateDetailsModel[]>('/certificates');

  return response.data;
};

const Certificates = {
  getCertificates,
  getCertificateDetails,
  getDrafts,
  addCertificate,
};

export default Certificates;
